<template>
    <div v-if="isLoaded">
        <div
            class="content-body"
            v-bind:class="{ fullscreen_expand: isFullscreen }"
        >
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour
                                name="gerarOCTour"
                                :steps="steps"
                                :callbacks="callbacksTour"
                            ></v-tour>
                            <h4 class="card-title step-inicio">
                                Gerar Ordem Coleta
                            </h4>
                            <a class="heading-elements-toggle"
                                ><i
                                    class="fa fa-ellipsis-v font-medium-3"
                                    @click="
                                        setSubMenuShowHideFw(
                                            getSubMenuShowHideFw()
                                        )
                                    "
                                ></i
                            ></a>
                            <div
                                class="heading-elements"
                                v-bind:class="{
                                    visible: getSubMenuShowHideFw(),
                                    '': !getSubMenuShowHideFw(),
                                }"
                            >
                                <ul class="list-inline mb-0">
                                    <li>
                                        <a
                                            @click="onTransferirClick()"
                                            v-b-tooltip
                                            title="Alterar unidade das notas fiscais"
                                            v-if="
                                                getPermissionFw(
                                                    'gerarordemcoleta.unidade'
                                                )
                                            "
                                            ><i
                                                class="ft-settings step-alterar"
                                            ></i
                                        ></a>
                                    </li>
                                    <li>
                                        <a
                                            @click="onCreateOc()"
                                            v-b-tooltip
                                            title="Agrupamento de notas fiscais"
                                            v-if="
                                                getPermissionFw(
                                                    'gerarordemcoleta.store'
                                                )
                                            "
                                            ><i class="ft-menu step-gerar"></i
                                        ></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div
                                    v-if="vuetableFilterRow"
                                    class="step-filtrar"
                                >
                                    <vuetable-filterbar> </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner
                                                v-if="loadingData"
                                                text-fg-color="#ffffff"
                                                message="Carregando..."
                                            ></spinner>
                                        </div>
                                    </div>
                                    <div>
                                        <a
                                            @click="searchAll()"
                                            v-b-tooltip
                                            title="Selecionar todas as páginas"
                                            v-if="
                                                getPermissionFw(
                                                    'gerarordemcoleta.store'
                                                )
                                            "
                                            ><i
                                                class="fa fa-check-square-o fa-lg"
                                                style="margin: 0px 0px 5px 4px"
                                            ></i
                                        ></a>
                                    </div>
                                    <vuetable
                                        ref="vuetable"
                                        api-url="/api/gerarordemcoleta"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        :row-class="onRowClass"
                                        track-by="docfis_id"
                                        pagination-path=""
                                        @vuetable:pagination-data="
                                            onPaginationData
                                        "
                                        @vuetable:cell-clicked="onDetail"
                                        @vuetable:loaded="onLoaded"
                                        detail-row-component="cte-veiculo-detalhes"
                                    >
                                        <template
                                            slot="actions"
                                            slot-scope="props"
                                        >
                                            <div class="custom-actions">
                                                <a
                                                    @click="
                                                        onDetail(props.rowData)
                                                    "
                                                    v-b-tooltip
                                                    title="Ver detalhes"
                                                    ><i class="fa fa-plus"></i
                                                ></a>
                                            </div>
                                        </template>
                                    </vuetable>
                                </div>
                                <div class="col-md-12">
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info
                                            ref="paginationInfo"
                                            :css="css.pagination"
                                            info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination
                                            ref="pagination"
                                            :css="css.pagination"
                                            @vuetable-pagination:change-page="
                                                onChangePage
                                            "
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TransferirNotasModal :notas="docfisIds" :options="unidades" />
    </div>
</template>

<script>
import { rowClassByDueDate } from "../utils";
import accounting from "accounting";
import CteVeiculoDetalhes from "./CteVeiculoDetalhes";
import GerarOrdemColetaFilterBar from "./GerarOrdemColetaFilterBar";
import moment from "moment";
import TransferirNotasModal from "./TransferirNotasModal.vue";
import vueDropzone from "vue2-dropzone";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";

Vue.component("cte-veiculo-detalhes", CteVeiculoDetalhes);

export default {
    name: "gerarOCTour",
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        "vuetable-filterbar": GerarOrdemColetaFilterBar,
        vueDropzone,
        TransferirNotasModal,
    },
    data() {
        return {
            callbacksTour: {
                onNextStep: this.tourNextStepCallback,
                onStop: this.tourStop,
            },
            steps: [
                {
                    target: ".step-inicio",
                    content: `Para gerar uma Ordem de Coleta é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`,
                },
                {
                    target: ".step-alterar",
                    content:
                        "Para transferir a nota fiscal para outra unidade, você deve selecionar as notas e clicar no botão ao lado.",
                    params: {
                        placement: "left",
                    },
                },
                {
                    target: ".step-gerar",
                    content:
                        "Para gerar uma Ordem de Coleta, você deve selecionar as notas e clicar no botão ao lado.",
                    params: {
                        placement: "left",
                    },
                },
                {
                    target: ".step-filtrar",
                    content:
                        "Para filtrar uma nota específica, você pode utilizar de diversos filtros.",
                    params: {
                        placement: "top",
                    },
                },
            ],
            date_attributes: [
                { key: "today", highlight: true, dates: new Date() },
            ],
            loading: false,
            loadingData: true,
            filter_data_store: {},
            filtrosForm: new Form({
                lote: "",
                nf_ini: "",
                nf_fim: "",
                fornecedor: "",
                dt_emissao_ini: "",
                dt_emissao_fim: "",
                dt_ini: "",
                dt_fim: "",
                dt_pre_ini: "",
                dt_pre_fim: "",
                atraso: "",
                redespacho: "",
            }),
            ordemColetaForm: new Form({
                docfis_ids: [],
            }),
            unidades: [],
            unidadesForm: new Form({}),
            docfisIds: [],
            fields: [
                {
                    name: "__checkbox",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
                {
                    name: "num_lote",
                    title: "Nº Lote",
                },
                {
                    name: "num_fiscal",
                    title: "Nº Fiscal",
                },
                {
                    name: "serie",
                    title: "Serie",
                },
                {
                    name: "dt_emissao",
                    title: "Data Emissão",
                    callback: "formatDate|DD/MM/YYYY",
                },
                {
                    name: "doc_fiscal_partes_env.emi_cnpj",
                    title: "CNPJ Fornecedor",
                },
                {
                    name: "doc_fiscal_partes_env.emi_nome",
                    title: "Razão Social Fornecedor",
                },
                {
                    name: "peso_bruto_total",
                    title: "Peso Bruto",
                    callback: this.formatNumber,
                },
                {
                    name: "qtd_volume",
                    title: "Volumes",
                },
                {
                    name: "vlr_total_nfs",
                    title: "Valor",
                    callback: this.formatNumber,
                },
                {
                    name: "dt_inc",
                    title: "Data de Inclusão",
                    callback: this.formatDateSubmit,
                },
                {
                    name: "dt_previsao",
                    title: "Data de Previsão",
                    callback: this.formatDateSubmit,
                },
                {
                    name: "doc_fiscal_partes_env.red_cnpj",
                    title: "CNPJ Redespacho",
                },
                {
                    name: "doc_fiscal_partes_env.red_nome",
                    title: "Razão Social Redespacho",
                },
                {
                    name: "__slot:actions",
                    title: "Ações",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
            ],
            css: {
                tableClass: "table",
                loadingClass: "loading",
                ascendingIcon: "glyphicon glyphicon-chevron-up",
                descendingIcon: "glyphicon glyphicon-chevron-down",
                handleIcon: "glyphicon glyphicon-menu-hamburger",
                detailRowClass: "vuetable-detail-row",
            },
            moreParams: {},
        };
    },
    mounted() {
        this.$events.$on("filter-set", (eventData) =>
            this.onFilterSet(eventData)
        );
        this.$events.$on("filter-reset", (e) => this.onFilterReset());
        this.loadUnidades();
    },
    methods: {
        onCreateOc() {
            this.docfisIds = this.$refs.vuetable.selectedTo;
            if (this.docfisIds.length == 0) {
                return this.throwErrorNotSelected();
            }

            this.$Simplert.open({
                title: "Atenção",
                message: `Deseja realmente gerar a Ordem de Coleta as ${this.docfisIds.length} notas selecionadas?`,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "warning",
                useConfirmBtn: true,
                onConfirm: () => {
                    this.loadingData = true;
                    this.ordemColetaForm.docfis_ids = this.docfisIds;
                    this.ordemColetaForm
                        .post("/api/gerarordemcoleta")
                        .then((response) => {
                            new ReturnApi(response, this);
                            this.loadingData = false;
                            this.$events.fire("filter-reset");
                        })
                        .catch((errors) => {
                            new ReturnApi(errors, this);
                            this.loadingData = false;
                        });
                },
                onClose: () => {
                    this.$Simplert.open({
                        title: "Ação cancelada",
                        message: "A Ordem de Coleta não foi gerada.",
                        customCloseBtnText: "Fechar",
                        type: "info",
                    });
                },
            });
        },
        throwErrorNotSelected() {
            return this.$Simplert.open({
                title: "Atenção",
                message: "Selecione pelo menos uma nota!",
                customCloseBtnText: "Fechar",
                type: "error",
            });
        },
        searchAll(data_filter, tipo) {
            if (tipo == 2) {
                this.filter_data_store = data_filter;
            }
            if (tipo != 2) {
                this.loadingData = true;
                if (this.$refs.vuetable.selectedTo.length == 0) {
                    this.filtrosForm.lote = this.filter_data_store.lote;
                    this.filtrosForm.nf_ini = this.filter_data_store.nf_ini;
                    this.filtrosForm.nf_fim = this.filter_data_store.nf_fim;
                    this.filtrosForm.fornecedor = this.filter_data_store.fornecedor;
                    this.filtrosForm.dt_emissao_ini = this.filter_data_store.dt_emissao_ini;
                    this.filtrosForm.dt_emissao_fim = this.filter_data_store.dt_emissao_fim;
                    this.filtrosForm.dt_ini = this.filter_data_store.dt_ini;
                    this.filtrosForm.dt_fim = this.filter_data_store.dt_fim;
                    this.filtrosForm.dt_pre_ini = this.filter_data_store.dt_pre_ini;
                    this.filtrosForm.dt_pre_fim = this.filter_data_store.dt_pre_fim;
                    this.filtrosForm.atraso = this.filter_data_store.atraso;
                    this.filtrosForm.redespacho = this.filter_data_store.redespacho;
                    this.filtrosForm
                        .post("/api/gerarordemcoleta/all")
                        .then((response) => {
                            new ReturnApi(response, this, true, false, false);
                            response.forEach((obj) => {
                                this.$refs.vuetable.selectedTo.push(
                                    parseFloat(obj)
                                );
                            });
                            this.loadingData = false;
                        })
                        .catch((errors) => {
                            new ReturnApi(errors, this);
                            this.loadingData = false;
                        });
                } else {
                    this.$refs.vuetable.selectedTo = [];
                    this.loadingData = false;
                }
            }
        },
        startTour() {
            this.$tours["gerarOCTour"].start();
        },
        tourNextStepCallback(currentStep) {
            // if(currentStep) Abrir o menu com opções
        },
        tourStop() {},
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onFilterSet(data_filter) {
            this.loadingData = true;
            this.moreParams = {
                lote: data_filter.lote,
                nf_ini: data_filter.nf_ini,
                nf_fim: data_filter.nf_fim,
                fornecedor: data_filter.fornecedor,
                dt_emissao_ini: data_filter.dt_emissao_ini,
                dt_emissao_fim: data_filter.dt_emissao_fim,
                dt_ini: data_filter.dt_ini,
                dt_fim: data_filter.dt_fim,
                dt_pre_ini: data_filter.dt_pre_ini,
                dt_pre_fim: data_filter.dt_pre_fim,
                atraso: data_filter.atraso,
                redespacho: data_filter.redespacho,
            };
            if (JSON.stringify(this.moreParams) != "{}") {
                this.searchAll(this.moreParams, 2);
            }
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset() {
            this.loadingData = true;
            this.$refs.vuetable.selectedTo = [];
            this.filter_data_store = {};
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onLoaded() {
            this.loadingData = false;
            this.$store.commit("setVuetableFilterButton", false);
        },
        onDetail(data) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatNumber(value) {
            return accounting.formatNumber(value, 2);
        },
        formatDate(value, fmt = "D MMM YYYY") {
            return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
        },
        formatDateSubmit(value, fmt = "DD/MM/YYYY HH:mm:ss") {
            return value == null || value == ""
                ? ""
                : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
        },
        onRowClass(data) {
            return rowClassByDueDate(
                data.dt_previsao,
                this.invoiceDueAlert,
                this.invoiceDueAlertDays);
        },
        loadUnidades() {
            this.unidadesForm
                .get("/api/gerarordemcoleta/unidades")
                .then((response) => {
                    this.unidades = response.map((unidade) => {
                        return {
                            label: `${unidade.cd} - ${unidade.descr}`,
                            value: unidade,
                        };
                    });
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
        },
        onTransferirClick() {
            this.docfisIds = this.$refs.vuetable.selectedTo;
            if (this.docfisIds.length == 0) {
                return this.throwErrorNotSelected();
            }
            this.$events.fire("open-modal-transferir-unidade");
        },
    },
    computed: {
        vuetableFilterRow: {
            get() {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        apiVersion: {
            get() {
                return this.$store.getters.api_version;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            },
        },
        isFullscreen: {
            get() {
                return this.$store.getters.is_full_screen;
            },
        },
        invoiceDueAlert() {
            return this.$store.getters.unidade_active.aviso_vencimento;
        },
        invoiceDueAlertDays() {
            return this.$store.getters.unidade_active.dias_vencimento;
        },
    },
};
</script>
